// Utility functions for handling logos

export const getLogoUrl = (logoPath: string | null | undefined): string | null => {
  // Always use the fixed logo file
  return '/The Aircons Ltd. Logo Org.png';
};

export const getDefaultLogoUrl = (): string => {
  // Return a default logo URL or use a data URL for a simple placeholder
  return '/The Aircons Ltd. Logo Org.png';
};

export const getBrandLogoUrl = (brandName: string, backendLogoPath?: string | null): string => {
  const localLogos: Record<string, string> = {
    'Fujiaire': '/Fujiaire.png',
    'Hitachi': '/Hitachi.png',
    'Dunham-Bush': '/Dunham-Bush.png'
  };

  // Check for exact or partial matches (e.g., "Fujiaire Brand" -> "Fujiaire")
  const normalizedName = Object.keys(localLogos).find(
    name => brandName.toLowerCase().includes(name.toLowerCase())
  );

  if (normalizedName) {
    return localLogos[normalizedName];
  }

  if (backendLogoPath) {
    if (backendLogoPath.startsWith('http')) {
      return backendLogoPath;
    }
    let baseUrl = process.env.REACT_APP_API_URL || '';
    if (baseUrl.endsWith('/api')) {
      baseUrl = baseUrl.slice(0, -4);
    } else if (baseUrl.endsWith('/api/')) {
      baseUrl = baseUrl.slice(0, -5);
    }
    const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const normalizedPath = backendLogoPath.startsWith('/') ? backendLogoPath : `/${backendLogoPath}`;
    return `${normalizedBaseUrl}${normalizedPath}`;
  }

  return '';
};

export const handleLogoError = (event: React.SyntheticEvent<HTMLImageElement, Event>, fallbackText?: string) => {
  const img = event.target as HTMLImageElement;
  console.error('Failed to load logo:', img.src);
  
  // Hide the broken image
  img.style.display = 'none';
  
  // Create fallback element
  const fallback = document.createElement('div');
  fallback.className = 'flex items-center justify-center bg-gray-100 border border-gray-300 rounded text-gray-500 text-sm';
  fallback.textContent = fallbackText || 'Logo not available';
  
  // Match the original image dimensions
  if (img.className.includes('h-')) {
    const heightMatch = img.className.match(/h-(\d+)/);
    if (heightMatch) {
      fallback.className += ` h-${heightMatch[1]}`;
    }
  }
  
  // Insert fallback after the image
  img.parentNode?.appendChild(fallback);
}; 